import { graphql } from 'react-relay/legacy.js';

export const interiorsLandingRootQuery = graphql`
    query interiorsLandingRootQuery($id: String, $getLive: Boolean) {
        viewer {
            ...InteriorsLandingWrapper_viewer
            metaData: interiorsLandingPage(id: $id, getLive: $getLive) {
                ogImage: roomsHeadModule {
                    imageUrl
                }
            }
        }
    }
`;
